<template>
    <vx-card id="loader">
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row header-title mb-4">
                    <h1>Площадки у которых завышен CTR</h1>
                </div>
            </vs-col>
        </vs-row>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/3 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Интервал </label>
                    <date-picker
                        range
                        @input="onChangeTimeInterval()"
                        :not-before="disabledBefore"
                        :shortcuts="[]"
                        v-model="dateInterval"
                        type="date"
                        format="YYYY-MM-DD"
                        placeholder="Интервал выборки"
                        :lang="'ru'"
                        :firstDayOfWeek="1"
                        class="date-p w-full"
                        :clearable="false"
                    >
                    </date-picker>
                </div>
            </div>
            <div class="vx-col w-1/3">
                <label class="vs-input--label"> Минимальное количество кликов</label>
                <div>
                    <vs-input v-model="form.minimalClicksCount" autocomplete="off" placeholder="" class="w-full" />
                </div>
            </div>
            <div class="vx-col w-1/3">
                <label class="vs-input--label"> SSP </label>
                <v-select
                    :options="dicts.sspTypes"
                    disabled
                    label="name"
                    placeholder="Выберите SSP"
                    :clearable="false"
                    class="w-full"
                    v-model="form.sspType"
                >
                </v-select>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col w-5/6 mb-1">
                <div class="mt-1">
                    <vs-button class="mt-2" color="success" @click="loadSites()" type="filled"> Применить </vs-button>
                </div>
            </div>
        </div>

        <vs-table :data="clickCheaters" max-items="10" class="mt-5">
            <template slot="thead">
                <vs-th></vs-th>
                <vs-th> Площадка </vs-th>
                <vs-th> CTR (средний: {{ ctrAverage }}) </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ indextr + 1 }}</vs-td>
                    <vs-td>{{ tr.siteName }}</vs-td>
                    <vs-td>{{ tr.value }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import DatePicker from 'vue2-datepicker';

const buyoutsDays = 7;

export default {
    name: 'blockClicksCheaters',
    data() {
        return {
            dateInterval: undefined,
            disabledBefore: this.$moment().add(-buyoutsDays, 'days').startOf('days'),
            ctrAverage: undefined,
            clickCheaters: [],
            form: {
                date_time_from: undefined,
                date_time_to: undefined,
                minimalClicksCount: '',
                sspType: {}
            },
            errors: {
                name: '',
                status: null
            },
            dicts: {
                sspTypes: []
            }
        };
    },
    watch: {
        dateInterval: function (newTime) {
            this.form.date_time_from = this.$moment(newTime[0]).format('YYYY-MM-DD ') + this.timeStart;
            this.form.date_time_to = this.$moment(newTime[1]).format('YYYY-MM-DD ') + this.timeEnd;
        }
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    methods: {
        loadData() {
            /*this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });*/
            this.axios;
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            // TODO change source
            this.axios.get('ssp').then((sspTypes) => {
                this.dicts.sspTypes = sspTypes.data;
                // this.$vs.loading.close('#loader > .con-vs-loading');
            });
        },
        loadSites() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                startPeriod: this.form.date_time_from,
                endPeriod: this.form.date_time_to,
                minimalClicksCount: this.form.minimalClicksCount,
                sspTypeId: this.form.sspType.id
            };

            this.axios
                .all([
                    this.axios.get('clickCheaters', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    })
                ])
                .then(
                    axios.spread((clickCheaters) => {
                        if (!clickCheaters.data) {
                            this.$vs.notify({
                                title: 'Ошибка!',
                                text: 'Нет данных для указаных параметров.',
                                color: 'warning'
                            });
                            this.ctrAverage = 0;
                            this.clickCheaters = [];
                            return;
                        }
                        this.clickCheaters = clickCheaters.data.sites;
                        this.ctrAverage = clickCheaters.data.ctrAverage;
                        this.$vs.loading.close('#loader > .con-vs-loading');
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        setDefaultValues() {
            let d = new Date();
            let yesterday = this.$moment(d.setDate(d.getDate() - 1)).format('YYYY-MM-DD ');
            let last3days = this.$moment(d.setDate(d.getDate() - 3)).format('YYYY-MM-DD ');

            this.timeStart = '00:00:00';
            this.timeEnd = '23:59:59';
            this.dateInterval = [last3days + this.timeStart, yesterday + this.timeEnd];
            this.onChangeTimeInterval();

            this.form.minimalClicksCount = 100;
            this.form.sspType = { name: 'Vitrina', id: '8' };
        },
        onChangeTimeInterval() {
            this.form.date_time_from = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD ') + this.timeStart;
            this.form.date_time_to = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD ') + this.timeEnd;
        }
    },
    mounted() {
        this.setDefaultValues();
        this.loadData();
        this.loadSites();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.header-title {
    flex-direction: column;
}

.textarea {
    border: 1px solid lightgrey !important;
    background-color: RGB(245, 245, 245);
}

.change-category {
    width: 200px;
}
</style>
<style scoped>
th >>> div {
    float: right;
}

tr >>> .vs-table--td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 4px 5px;
    text-align: right;
    font-family: sans-serif;
    font-size: 16px;
}
</style>